var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"b",attrs:{"id":"scroll-button","title":"Scroll to top"},on:{"click":_vm.scrollToTop}},[_c('span',{staticClass:"icon-chevron-up"})])
}
var staticRenderFns = []

export { render, staticRenderFns }